namespace GeniuzPOS.Lookups {
    export namespace VwUserService {
        export const baseUrl = 'Lookups/VwUser';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwUserRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwUserRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwUser/Retrieve",
            List = "Lookups/VwUser/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwUserService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
